import api from '@/utils/api';
import {
    GET_LIST_PROJECT,
    UPDATE_SPECIFIC_PROJECT,
    CREATE_NEW_PROJECT,
    REMOVE_PROJECT,
    GET_PROJECT_ACTIVE,
    CLONE_PROJECT
} from './types';
import { NotificationManager } from 'react-notifications';

const showRequestError = (error) => {
    NotificationManager.error(error.response?.data?.msg || 'Đã xảy ra lỗi, vui lòng thử lại.');
};

export const getProjects = filter => dispatch => api
    .get('/projects', { params: filter })
    .then(response => {
        dispatch({ type: GET_LIST_PROJECT, payload: response.data.data });
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const getProject = id => () => api
    .get(`/projects/${id}`)
    .then(response => response.data.data)
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const getActiveProjects = filter => dispatch => api
    .get('/projects/active', { params: filter })
    .then(response => {
        dispatch({ type: GET_PROJECT_ACTIVE, payload: response.data.data });
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const createProject = data => dispatch => api
    .post('/projects', data)
    .then(response => {
        dispatch({ type: CREATE_NEW_PROJECT, payload: response.data.data });
        NotificationManager.success('Thêm mới bản ghi thành công!');
        return response.data.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const updateProject = (id, data) => dispatch => api
    .put(`/projects/${id}`, data)
    .then(response => {
        dispatch({ type: UPDATE_SPECIFIC_PROJECT, payload: response.data.data });
        NotificationManager.success('Cập nhật bản ghi thành công!');
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const removeProjects = ids => dispatch => api
    .delete('/projects', { data: { ids } })
    .then(response => {
        dispatch({ type: REMOVE_PROJECT, payload: ids });
        NotificationManager.success('Xoá bản ghi thành công!');
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const cloneProjects = ids => dispatch => api
    .post('/projects/clone', { ids })
    .then(response => {
        dispatch({ type: CLONE_PROJECT, payload: ids });
        NotificationManager.success(response.data.msg);
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });
